var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-layout"},[_c('app-header',{staticClass:"app-header"}),_c('app-main',{staticClass:"app-main",style:({minHeight: `${_vm.height}px`})}),_c('app-footer',{staticClass:"app-footer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }